import {
  checkoutOptimizationStepSchema,
  triggerStepSchema,
} from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getScheduledSplitTrees = {
  name: "getScheduledSplitTrees" as const,
  input: z.null(),
  output: z.object({
    scheduledSplitTrees: z.array(
      z.object({
        splitId: zExt.objectId(),
        splitName: z.string(),
        steps: z
          .array(z.union([checkoutOptimizationStepSchema, triggerStepSchema]))
          .optional(),
        concludedSteps: z
          .array(z.union([checkoutOptimizationStepSchema, triggerStepSchema]))
          .optional(),
      }),
    ),
  }),
};
export type GetScheduledSplitTreesOutput = z.infer<
  typeof getScheduledSplitTrees.output
>;
